import { additionalGivingNetworksByScenario } from "./additionalGivingNetworks";

const mockResponses = { additionalGivingNetworksByScenario };

export default mockResponses;
